<template>
  <p>For inquiries specifically relating to registration or payments, please contact us using the following address:</p>
  <Email to="vizbi-registration" :outstanding="true" />
  <p>
    For inquiries relating to onsite logistics or online participation, please contact the
    <a href="https://keckusc.cloud-cme.com/contact/?p=35">USC Office of Continuing Medical Education</a> via:
  </p>
  <Email to="lisa-delgado" :outstanding="true" />
  <!-- <p>For all inquiries relating to the Masterclass please contact:</p>
  <Email to="masterclass" :outstanding="true" /> -->
  <p>
    For inquiries relating to scientific aspects of the program, or about sponsorship opportunities, please contact:
  </p>
  <Email to="vizbi-contact" :outstanding="true" />
</template>

<script setup>
import Email from "@/components/Email.vue";
</script>

<style scoped>
p:not(:first-child) {
  margin-top: 18px;
}
</style>
